module.exports = __webpack_public_path__ + "static/img/icn_payment_fail@3x.073fa09.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/common/icn_payment_fail@3x.png
// module id = lyLv
// module chunks = 10